import {useSearchParams} from 'react-router';
import {TextoConFormato} from '../componentes/texto-con-formato';
import {tr} from '../i18n/idioma';

// Guia de uso dentro de la app (Daniel, 8/10/2026): una pestaña por seccion.
// El texto vive en src/guia/*.md (en espanol) y es el mismo de la guia
// compartida; se actualiza con cada cambio visible de la app.
const archivos = import.meta.glob('../guia/*.md', {query: '?raw', import: 'default', eager: true}) as Record<
  string,
  string
>;

// Orden por el numero del nombre (05.5-dore va entre 05 y 06).
const numeroDe = (ruta: string) => Number(/\/([\d.]+)-[^/]*$/.exec(ruta)?.[1] ?? Infinity);
const SECCIONES = Object.entries(archivos)
  .sort(([a], [b]) => numeroDe(a) - numeroDe(b) || a.localeCompare(b))
  .map(([ruta, texto]) => {
    const clave = ruta.replace(/^.*\/[\d.]+-/, '').replace(/\.md$/, '');
    const titulo = /^#\s+(.*)$/m.exec(texto)?.[1] ?? clave;
    return {clave, titulo, texto};
  });

export function PaginaGuia() {
  const [parametros, setParametros] = useSearchParams();
  const actual = SECCIONES.find(s => s.clave === parametros.get('seccion')) ?? SECCIONES[0]!;
  return (
    <section className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold text-verde-oscuro">{tr('Guía de uso', 'User guide')}</h1>
        <p className="text-sm text-apagado">
          {tr(
            'Qué hace cada sección, para qué sirve y cómo se usa. Se actualiza con cada cambio de la app.',
            'What each section does, what it is for and how to use it. Updated with every app change (in Spanish).',
          )}
        </p>
      </div>
      <div className="flex flex-wrap gap-6">
        <nav aria-label={tr('Secciones de la guía', 'Guide sections')} className="w-full max-w-60 shrink-0">
          <ul className="space-y-0.5">
            {SECCIONES.map(s => (
              <li key={s.clave}>
                <button
                  type="button"
                  aria-current={s.clave === actual.clave ? 'page' : undefined}
                  onClick={() => setParametros({seccion: s.clave})}
                  className={`w-full rounded-md px-3 py-2 text-left text-sm ${
                    s.clave === actual.clave
                      ? 'bg-verde-claro font-medium text-verde-oscuro'
                      : 'text-tinta hover:bg-papel'
                  }`}
                >
                  {s.titulo}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <article
          className="min-w-0 flex-[999_1_480px] rounded-lg border border-linea bg-white p-6"
          data-prueba="guia-de-uso"
        >
          <TextoConFormato texto={actual.texto} />
        </article>
      </div>
    </section>
  );
}
